import register from './register.json';
import main from './main.json';
import employees from './employees.json';
import attendance from './attendance.json';
import payroll from './payroll.json';
import settings from './settings.json';
import academics from './academics.json';
import finance from './finance.json';
import students from './students.json';
import tuition from './tuition.json';
import hardware from './hardware.json';

export const en = {
    ...register,
    ...main,
    ...employees,
    ...attendance,
    ...payroll,
    ...settings,
    ...academics,
    ...finance,
    ...students,
    ...tuition,
    ...hardware
};
